import { z } from 'zod';

const validationSchema = z.object({
  privateMessage: z.string().nullable(),
});

export default validationSchema;
